import { apiResource } from "../../utils";

export function EventHero({ event }) {
  const desktop = apiResource({ url: event.banner_desktop_event || event.banner_large_event });
  const tablet  = apiResource({ url: event.banner_tablet_event  || event.banner_large_event });
  const mobile  = apiResource({ url: event.banner_mobile_event  || event.banner_large_event });

  return (
    <div
      className="hero-section"
      style={{
        "--img-desktop": `url("${desktop}")`,
        "--img-tablet": `url("${tablet}")`,
        "--img-mobile": `url("${mobile}")`,
      }}
    >
      <div className="hero-bg" />
      <div className="hero-overlay" />

      <div className="hero-content px-3">
        <div className="mb-4">
          <h1 className="hero-title">{event.name_event}</h1>
        </div>

        <p className="hero-subtitle">{event.subtitle_event}</p>

        <div className="hero-info">
          <div className="info-item">
            <svg className="icon-small" fill="currentColor" viewBox="0 0 20 20">
              <path d="M5.5 13a3.5 3.5 0 01-.369-6.98 4 4 0 117.753-1.3A4.5 4.5 0 1113.5 13H11V9.413l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13H5.5z" />
            </svg>
            <span>{event.full_date_formatted}</span>
          </div>

          <div className="info-item">
            <svg className="icon-small" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
              />
            </svg>
            <span>{event.location_event}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
